import { DeviceManifest } from '@rapoo/device-sdk'
import {
  esk900KeyboardConfig,
  itineraryEnabled,
  keyFeaturesFull,
  keyboardMacro,
} from './generate/capabilityPresets'
import { esk90075Keys } from './generate/keysGenerate'
import {
  esk900KeyboardLightingEffects,
  esk900SideLightingEffects,
} from './generate/lightingPresets'

/**
 * ESK900-75RT 设备清单
 **/
const rapooESK90075RT: DeviceManifest = {
  channel: ['china_cybercafe'],
  model: 'ESK900-75RT',
  mainControl: 'ESK900-75RT',
  type: 'keyboard',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: [0x482a],
    currentPid: 0x482a,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 2,
        description: 'Configuration Interface (Secondary)',
        type: 'default',
      },
      {
        usagePage: 65392,
        usage: 113,
        description: 'Only update Firmware',
        type: 'update',
      },
    ],
  },
  driver: 'CH585M',
  ui: {
    assetsDir: 'manifests/ESK900-75RT',
    // 颜色配置
    colors: {
      series: [
        {
          name: 'common.products.ESK900_75RT.Blade_Pink',
          value: '#E54F4F',
          key: 'Blade_Pink',
        },
      ],
      current: 'Blade_Pink',
    },
    // 小图标
    icon: 'Hardware-Wireframe-Keyboard',
    // 是否支持设备概览
    overview: false,
  },
  capabilities: [
    esk900KeyboardConfig,
    {
      type: 'lighting',
      config: {
        enable: true,
        effects: [...esk900KeyboardLightingEffects, ...esk900SideLightingEffects],
      },
    },
    itineraryEnabled,
    keyFeaturesFull,
    {
      type: 'keys',
      config: esk90075Keys,
    },
    keyboardMacro,
  ],
  layout: {
    image: 'frame',
    top: 28,
    bottom: 16,
    left: 16,
    right: 16,
    unit: 40,
    keys: [
      [
        {
          key: 0,
          keywords: 'Esc',
        },
        {
          key: 1,
          keywords: 'F1',
          x: 0.25,
        },
        {
          key: 2,
          keywords: 'F2',
        },
        {
          key: 3,
          keywords: 'F3',
        },
        {
          key: 4,
          keywords: 'F4',
        },
        {
          key: 5,
          keywords: 'F5',
          x: 0.25,
        },
        {
          key: 6,
          keywords: 'F6',
        },
        {
          key: 7,
          keywords: 'F7',
        },
        {
          key: 8,
          keywords: 'F8',
        },
        {
          key: 9,
          keywords: 'F9',
          x: 0.25,
        },
        {
          key: 10,
          keywords: 'F10',
        },
        {
          key: 11,
          keywords: 'F11',
        },
        {
          key: 12,
          keywords: 'F12',
        },
      ],
      [
        {
          key: 22,
          keywords: '~_`',
          y: 0.2,
        },
        {
          key: 23,
          keywords: '!_1',
          y: 0.2,
        },
        {
          key: 24,
          keywords: '@_2',
          y: 0.2,
        },
        {
          key: 25,
          keywords: '#_3',
          y: 0.2,
        },
        {
          key: 26,
          keywords: '$_4',
          y: 0.2,
        },
        {
          key: 27,
          keywords: '%_5',
          y: 0.2,
        },
        {
          key: 28,
          keywords: '^_6',
          y: 0.2,
        },
        {
          key: 29,
          keywords: '&_7',
          y: 0.2,
        },
        {
          key: 30,
          keywords: '*_8',
          y: 0.2,
        },
        {
          key: 31,
          keywords: '(_9',
          y: 0.2,
        },
        {
          key: 32,
          keywords: ')_0',
          y: 0.2,
        },
        {
          key: 33,
          keywords: '__-',
          y: 0.2,
        },
        {
          key: 34,
          keywords: '+_=',
          y: 0.2,
        },
        {
          key: 35,
          keywords: 'BackSpace',
          y: 0.2,
          w: 2,
        },
        {
          key: 36,
          keywords: 'Delete',
          y: 0.2,
          x: 0.1,
        },
      ],
      [
        {
          key: 44,
          keywords: 'Tab',
          y: 0.2,
          w: 1.5,
        },
        {
          key: 45,
          keywords: 'Q',
          y: 0.2,
        },
        {
          key: 46,
          keywords: 'W',
          y: 0.2,
        },
        {
          key: 47,
          keywords: 'E',
          y: 0.2,
        },
        {
          key: 48,
          keywords: 'R',
          y: 0.2,
        },
        {
          key: 49,
          keywords: 'T',
          y: 0.2,
        },
        {
          key: 50,
          keywords: 'Y',
          y: 0.2,
        },
        {
          key: 51,
          keywords: 'U',
          y: 0.2,
        },
        {
          key: 52,
          keywords: 'I',
          y: 0.2,
        },
        {
          key: 53,
          keywords: 'O',
          y: 0.2,
        },
        {
          key: 54,
          keywords: 'P',
          y: 0.2,
        },
        {
          key: 55,
          keywords: '{_[',
          y: 0.2,
        },
        {
          key: 56,
          keywords: '}_]',
          y: 0.2,
        },
        {
          key: 57,
          keywords: '|_\\',
          y: 0.2,
          w: 1.5,
        },
        {
          key: 58,
          keywords: 'PgUp',
          y: 0.2,
          x: 0.1,
        },
      ],
      [
        {
          key: 66,
          keywords: 'CapsLock',
          y: 0.2,
          w: 1.75,
        },
        {
          key: 67,
          keywords: 'A',
          y: 0.2,
        },
        {
          key: 68,
          keywords: 'S',
          y: 0.2,
        },
        {
          key: 69,
          keywords: 'D',
          y: 0.2,
        },
        {
          key: 70,
          keywords: 'F',
          y: 0.2,
        },
        {
          key: 71,
          keywords: 'G',
          y: 0.2,
        },
        {
          key: 72,
          keywords: 'H',
          y: 0.2,
        },
        {
          key: 73,
          keywords: 'J',
          y: 0.2,
        },
        {
          key: 74,
          keywords: 'K',
          y: 0.2,
        },
        {
          key: 75,
          keywords: 'L',
          y: 0.2,
        },
        {
          key: 76,
          keywords: ':_;',
          y: 0.2,
        },
        {
          key: 77,
          keywords: '"_\'',
          y: 0.2,
        },
        {
          key: 78,
          keywords: 'Enter',
          y: 0.2,
          w: 2.25,
        },
        {
          key: 79,
          keywords: 'PgDn',
          y: 0.2,
          x: 0.1,
        },
      ],
      [
        {
          key: 88,
          keywords: 'Shift_L',
          y: 0.2,
          w: 2.25,
        },
        {
          key: 89,
          keywords: 'Z',
          y: 0.2,
        },
        {
          key: 90,
          keywords: 'X',
          y: 0.2,
        },
        {
          key: 91,
          keywords: 'C',
          y: 0.2,
        },
        {
          key: 92,
          keywords: 'V',
          y: 0.2,
        },
        {
          key: 93,
          keywords: 'B',
          y: 0.2,
        },
        {
          key: 94,
          keywords: 'N',
          y: 0.2,
        },
        {
          key: 95,
          keywords: 'M',
          y: 0.2,
        },
        {
          key: 96,
          keywords: '<_,',
          y: 0.2,
        },
        {
          key: 97,
          keywords: '>_.',
          y: 0.2,
        },
        {
          key: 98,
          keywords: '?_/',
          y: 0.2,
        },
        {
          key: 99,
          keywords: 'Shift_R',
          y: 0.2,
          w: 1.75,
        },
        {
          key: 100,
          keywords: '↑',
          y: 0.2,
        },
      ],
      [
        {
          key: 110,
          keywords: 'Ctrl_L',
          y: 0.2,
          w: 1.25,
        },
        {
          key: 111,
          keywords: 'Win_L',
          y: 0.2,
          w: 1.25,
        },
        {
          key: 112,
          keywords: 'Alt_L',
          y: 0.2,
          w: 1.25,
        },
        {
          key: 113,
          keywords: 'Space_L',
          y: 0.2,
          w: 6.25,
        },
        {
          key: 114,
          keywords: 'Fn',
          y: 0.2,
          w: 1.25,
        },
        {
          key: 115,
          keywords: 'Ctrl_R',
          y: 0.2,
          w: 1.25,
        },
        {
          key: 116,
          keywords: '←',
          y: 0.2,
          x: 0.5,
        },
        {
          key: 117,
          keywords: '↓',
          y: 0.2,
        },
        {
          key: 118,
          keywords: '→',
          y: 0.2,
        },
      ],
    ],
  },
}

export default rapooESK90075RT
